import { useSyncExternalStore } from "react";

const doneAlready = "doneAlready";
const doneAlreadyDate = "doneAlreadyDate";

// Local calendar date as YYYY-MM-DD. Using local (not UTC) components avoids
// rolling the day over at the wrong time for non-UTC timezones.
const getLocalDateKey = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Normalize whatever is stored to a YYYY-MM-DD key. Older builds persisted a
// full `Date.toString()`, so parse it back to a date key for comparison.
const normalizeStoredDate = (stored: string | null): string | null => {
  if (!stored) {
    return null;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(stored)) {
    return stored;
  }
  const parsed = new Date(stored);
  return Number.isNaN(parsed.getTime()) ? null : getLocalDateKey(parsed);
};

let currentCount = 0;
const listeners = new Set<() => void>();

try {
  const storedDate = normalizeStoredDate(localStorage.getItem(doneAlreadyDate));
  const storedCount = parseInt(localStorage.getItem(doneAlready) || "0", 10);

  // Only keep the count when the stored date is the same calendar day and the
  // count is a finite number; otherwise start the day at zero.
  currentCount =
    storedDate === getLocalDateKey() && Number.isFinite(storedCount)
      ? storedCount
      : 0;
} catch {
  // Ignore localStorage parsing errors
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return currentCount;
}

function increment() {
  currentCount += 1;
  localStorage.setItem(doneAlready, currentCount.toString());
  localStorage.setItem(doneAlreadyDate, getLocalDateKey());
  listeners.forEach((listener) => listener());
}

export const useCountReviewedResponses = (): {
  count: number;
  increment: () => void;
} => {
  const count = useSyncExternalStore(subscribe, getSnapshot);
  return { count, increment };
};
